<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p class="d-flex align-items-center">
         <span>{{`${(staff && staff.firstName) ?  staff.firstName + "'s" : "Staff"} details`}}</span>
          <star-rating class="ml-2" v-model="staffRating" :show-rating="false" :star-size="starSize"></star-rating>
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <label class="uplift">{{$t('text.editStaff.personalInformation')}}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.firstName')}}
                </span>
              </label>
              <div class="input__block" ref="fname_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.firstName')"
                  v-model="staff.firstName"
                  class="form-control"
                  disabled
                   style="width: 100%"
                />
              </div>
              <div ref="fname_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.lastName')}}
                </span>
              </label>
              <div class="input__block" ref="lname_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.lastName')"
                  class="form-control"
                  v-model="staff.lastName"
                  disabled
                   style="width: 100%"
                />
              </div>
              <div ref="lname_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.cardName')}}
                </span>
              </label>
              <div class="input__block" ref="card_name_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.cardName')"
                  v-model="staff.cardName"
                  class="form-control"
                  disabled 
                   style="width: 100%"
                />
              </div>
              <div ref="card_name_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.dateOfBirth')}}
                </span>
              </label>
              <div class="input__block">
                 <input
                  type="text"
                  v-model="staff.dateOfBirth"
                  class="form-control"
                  @blur="captureFormEvents($event)"
                  disabled
                  style="width:100%"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                {{$t('text.editStaff.gender')}}
              </label>
              <div class="input__block">
                <input
                  type="text"
                  v-model="staff.gender"
                  class="form-control"
                  disabled
                   style="width: 100%"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.email')}}
                </span>
              </label>
              <div class="input__block" ref="email_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.email')"
                  v-model="staff.email"
                  class="form-control"
                  disabled
                   style="width: 100%"
                />
              </div>
              <div ref="email_error"></div>
            </div>
          </div>
        </div>
        <div class="contact">
          <label class="uplift">{{$t('text.editStaff.contactInformation')}}</label>
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.streetAddress')}}
                </span>
              </label>
              <div class="input__block" ref="street_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.streetAddress')"
                  v-model="staff.street"
                  class="form-control"
                  disabled
                   style="width: 100%"
                />
              </div>
              <div ref="street_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.city')}}
                </span>
              </label>
              <div class="input__block" ref="city_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.city')"
                  v-model="staff.city"
                  class="form-control"
                  disabled
                   style="width: 100%"
                />
              </div>
              <div ref="city_error"></div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                {{$t('text.editStaff.state')}}
              </label>
              <div class="input__block">
                <select v-model="staff.state"  style="width: 100%" disabled>
                  <option :value="st.name" v-for="(st,i) in states" :key='i'>{{st.name}}</option>
                </select>
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.country')}}
                </span>
              </label>
              <div class="input__block" ref="country_input">
                <input
                  style="width: 100%;"
                  type="text"
                  :placeholder="this.$t('text.editStaff.country')"
                  class="form-control"
                  v-model="staff.country"
                  disabled
                />
              </div>
              <div ref="country_error"></div>
            </div>
              <div class="input__group__block mt-4 col-md-6" style="margin: 0;">
              <label class="required">
                <span class="mylabel">
                  {{$t('text.editStaff.phone')}}
                </span>
              </label>
              <div class="input__block" ref="phone_input">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.phone')"
                  style="width: 100%"
                  v-model="staff.phone"
                  class="form-control"
                  disabled
                />
              </div>
              <div ref="phone_error"></div>
            </div>
          </div>
        </div>

 
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";

import JQuery from "jquery";
let $ = JQuery;
import StarRating from 'vue-star-rating'

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "VerifyReceipt",
  components: {
    MasterLayout,
    StarRating
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport]
  },
  data() {
    return {
       startDate: this.$moment().subtract(30, "days").format("YYYY-MM-DDTHH:mm:ss"),
      endDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      dateRange: { "start": this.startDate, "end":this.endDate },
      starSize: 20,

      firstName: "NiL",
      lastName: "NiL",
      cardName: "NiL",
      city: "NiL",
      email: "NiL",
      gender: "NiL",
      street: "NiL",
      state: "Lagos",
      phone: "NiL",
      states: [],
      staff: {},
      country: "Nigeria",
      branch: {},
      branchId: null,
      formIsValid: false,
      isButtonDisabled: false,
      staffRating: 0,
      
      showLoader: true,
      retainerships: "NiL",
      backgroundUrl,
      payTime: "",
      fileDisabled: true,
      pageSettings: { pageSizes: [10, 20, 50, 100, 200], pageCount: 4, pageSize: 10 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    document.title = "View Staff:: Epump etail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch
      document.title = `View Staff:: ${branch.name} Retail Outlet`;
    })
     this.$eventHub.$on("editStaff", (staff) => {
          this.staff = staff;
              });
  },
  beforeDestroy(){
    
    this.$eventHub.$off("editStaff");
  },
  watch: {
    branch: function(newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
      }
      if (this.branchId !== null) {
        this.getStates();
        this.getStaff()
        this.getStaffRating()
      }
    }
  },
  mounted() {
    this.dateRange.start = this.startDate
    this.dateRange.end = this.endDate
  },
  methods: {
    getStaffRating() {
     this.showLoader = true
      this.axios
        .get(
          `${configObject.apiBaseUrl}/TransactionRating/Staff/${this.$route.params.staffId}?startDate=${this.dateRange.start}&endDate=${this.dateRange.end}`,
          configObject.authConfig()
        )
        .then((res) => {
            this.staffRating = Math.floor(res.data.averageRateValue)
        })
        .catch((e) => {
            this.showLoader = false
        });
    },
    getStaff() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Staff/BranchStaff/${this.branchId}`,
          configObject.authConfig()
        )
        .then(response => {
          this.staff = response.data.filter(staff => staff.id == this.$route.params.staffId)[0]

          let DOB = new Date(this.staff.dateOfBirth);
          const newDOB = this.$moment(DOB, "MM/DD/YYYY").format("DD/MM/YYYY");
          this.staff.dateOfBirth = newDOB;
        })
        .catch(error => {
          // this.$toast.open({
          //   message: "Failed to get Staff",
          //   type: "error",
          //   duration: 5000
          // });
        });
    },

    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getStates() {
      this.axios
        .get(
         `${configObject.apiBaseUrl}/Branch/States`, 
          configObject.authConfig()
        )
        .then(response => {
          this.states = response.data;
         
        })
        .catch(error => {
        });
    },
  }
};
</script>
